import React from 'react';

// A failed request, shown under the control that sent it until the next try.
export default function InlineError({ message, className = '' }) {
	if(!message) {
		return null;
	}
	return (
		<div className={`inline-error ${className}`.trim()} role='alert'>
			<i className='fa fa-exclamation-triangle' aria-hidden='true' />
			<span>{message}</span>
		</div>
	);
}
